"use client"

import { ArrowRight } from "lucide-react"

import { useSiteWallet } from "@shared/web3"
import { MobileBottomBar } from "@shared/ui/landing/mobile-bottom-bar"
import { Button } from "@shared/ui/components/button"

import { useTranslations } from "@/lib/i18n/client"

export function MobileBottomCta() {
  const t = useTranslations("cta")
  const tHeader = useTranslations("header")
  const { isConnected, openModal } = useSiteWallet()

  return (
    <MobileBottomBar className="border-brand bg-white/95">
      <div className="flex items-center gap-2">
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold text-brand">{t("title")}</p>
          <p className="truncate text-xs text-muted-foreground">{t("subtitle")}</p>
        </div>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="shrink-0 border-brand text-brand hover:bg-brand-light/50"
          onClick={() => {
            document.getElementById("buy")?.scrollIntoView({ behavior: "smooth" })
          }}
        >
          {t("button")}
          <ArrowRight className="size-4" />
        </Button>
        {!isConnected ? (
          <Button
            type="button"
            size="sm"
            className="shrink-0 bg-brand text-white hover:bg-brand/90"
            onClick={() => openModal()}
          >
            {tHeader("connectWallet")}
          </Button>
        ) : null}
      </div>
    </MobileBottomBar>
  )
}
